import { driver } from 'driver.js';
import { RHFTextField } from '../hook-form';
import Iconify from '../Iconify';
import { IconButton } from '@mui/material';
import ReactDOMServer from 'react-dom/server';

const GeneralDriverTextFiled = ({ name, helperTitle, helperDesc, ...RHFTProps }) => {
  const startTour = () => {
    const driveInstance = driver({
      doneBtnText: 'باشه ',
      nextBtnText: 'بعدی',
      prevBtnText: 'قبلی',
      progressText: ' ',
      showButtons: [false, false, true],
      smoothScroll: true,
      steps: [
        {
          element: `.${name}`,
          popover: {
            title: helperTitle || RHFTProps.label,
            description: typeof helperDesc == 'string' ? helperDesc : ReactDOMServer.renderToString(helperDesc),
          },
        },
      ],
      showProgress: true,
    });
    driveInstance.drive();
  };

  return (
    <RHFTextField
      className={name}
      name={name}
      InputProps={{
        endAdornment: (
          <IconButton className={RHFTProps.multiline ? 'self-end' : 'self-center'} onClick={startTour}>
            <Iconify sx={{ width: { xs: '16px', md: '20px' } }} icon={'ic:outline-info'} />
          </IconButton>
        ),
      }}
      {...RHFTProps}
    />
  );
};

export default GeneralDriverTextFiled;
